import $ from 'jquery';
import componentize from '../../utils/componentize';
import generateRandomInteger from '../../utils/generate_random_integer';
const slick = require('slick-carousel'); // eslint-disable-line no-unused-vars

export default function () {
    return componentize({
        query: '.slideshow',
        attachedCallback: function () {
            const $this = $(this);
            this.$el = $this;

            // these are default settings that all of our carousels tend to use
            let slickConfig = {
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow"></i></button>',
                slide: '.slide'
            };

            // this is for MIC sector slider navigation
            if ($this.hasClass('mic-sector-list')) {
                slickConfig = this.buildPagination.call(this, slickConfig);
            }

            if ($this.hasClass('highlight-list')) {
                let min = 0;
                let max = $this.find('.slide').length - 1;
                slickConfig.initialSlide = generateRandomInteger(min, max);
            }

            this.initializeCarousel(slickConfig);
        },
        buildPagination: function (slickConfig) {
            slickConfig.dots = true;
            slickConfig.slide = '.slide';
            slickConfig.customPaging = this.customPaging;
            return slickConfig;
        },
        customPaging: function (slider, i) {
            const buttonPaging = {
                0: 'A-D',
                1: 'E-G',
                2: 'H-L',
                3: 'M-R',
                4: 'S-Z'
            };
            return '<button type="button" class="sector-list-page" data-role="none" role="button" aria-required="false" tabindex="0">' + (buttonPaging[i]) + '</button>';
        },
        initializeCarousel: function (slickConfig) {
            const $this = this.$el;
            $this.slick(slickConfig);
        }
    });
}
